import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityDetailedContent,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconItemAdd from '@/icons/ItemAdd.svg';
import { useDatabaseTranslation } from '@/services/i18n';
import { formatCurrency } from '@/utils/number';

export const ArticleActionRefusedByClientActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'article_action_refused_by_client'>;
  displayArticleName: boolean;
}) => {
  const { _db } = useDatabaseTranslation();
  const creatorName = activity.creator?.name;
  const actionName = activity.data?.action?.name ? _db(activity.data.action.name) : undefined;
  const organizationPrice =
    activity.data?.action?.customOrganizationPrice?.amountBeforeTaxes !== null &&
    activity.data?.action?.customOrganizationPrice?.amountBeforeTaxes !== undefined
      ? activity.data.action.customOrganizationPrice
      : activity.data?.action?.catalogOrganizationPrice;
  const price = organizationPrice
    ? formatCurrency(organizationPrice.amount, organizationPrice.currency)
    : undefined;

  return (
    <BaseActivity
      key={activity.id}
      createdAt={activity.createdAt}
      icon={<IconItemAdd />}
      message={
        <BaseActivityText>
          {creatorName ? (
            <Trans id="activities.article_action_refused_by_client.message">
              <strong>{creatorName}</strong> refused the action {actionName} for the item{' '}
              <BaseActivityArticleName
                activity={activity}
                displayArticleName={displayArticleName}
              />{' '}
              on behalf of the client
            </Trans>
          ) : (
            <Trans id="activities.article_action_refused_by_client.message.no-creator">
              The client refused action {actionName} for the item{' '}
              <BaseActivityArticleName
                activity={activity}
                displayArticleName={displayArticleName}
              />{' '}
            </Trans>
          )}
        </BaseActivityText>
      }
    >
      <BaseActivityDetailedContent>
        {price && (
          <Trans id="activities.article_action_refused_by_client.price">
            Client Price (incl. VAT): {price}
          </Trans>
        )}
      </BaseActivityDetailedContent>
    </BaseActivity>
  );
};
